
import { Injectable } from '@angular/core';
import {
  AppFirestoreService,
  AppFirestoreCollection,
  AppFirestoreDocument,
} from './app-firestore.service';
import { Item } from '../_core/_interface/item';
import { Building } from '../_core/_interface/building';
import { Page } from '../_core/_interface/page';

import { Observable, Subject } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConstructionPoint } from '../_core/_interface/consdtruction-point';
import {
  AngularFireStorage,
  AngularFireUploadTask
} from '@angular/fire/compat/storage';
import { nextTick } from 'q';
import { Client } from '../_core/_interface/clients';
import { Floors } from '../_core/_interface/floors';
import { Flat } from '../_core/_interface/flat';
import { FlatPrototype } from '../_core/_interface/flat-prototype';
import { ActivatedRoute, Router } from '@angular/router';



@Injectable({
  providedIn: 'root'
})

export class DataService {
  itemsCollection: AppFirestoreCollection<Item>;
  items: Observable<any>;
  itemDoc: AppFirestoreDocument<Item>;
  projDoc: any;
  itemBuild: any;
  proj: any;
  company: any;
  sehelDomain: string = 'https://crm.sehel.co.il/api/3d/';
  // private showFromMenu = new BehaviorSubject<any>({});
  public showBuilding = new Subject<any>();
  public floorIdPlane = new Subject<any>();
  public currentProj = new Subject<any>();
  public currentBuilding = new BehaviorSubject<any>(null);
  public currentUnit = new BehaviorSubject<any>(null);
  public currentComp = new Subject<any>();


  public compId = new BehaviorSubject<string>('');
  public projId: string;
  public buildId: string;
  public buildUid: string;
  public selectedBuildId: string;
  public floorId: string;
  public flatPrototypeId: string;
  public flat: string;
  public prototypeId: string;
  public constructionPoint: ConstructionPoint;
  public projUid: string;
  public metadataName;
  public parentId: string;

  curParentId = this.compId.asObservable();
  public showFlatProperties = new Subject<any>();
  public curProjects = new Subject<any>();
  public numRoomsFilter = new Subject<any>();
  public currentPrototype = new Subject<any>();
  public fullWidthPropertiesFlatPanel = new Subject<any>();
  public flatStatusClass = new Subject<any>();
  public floorsNumbers = new Subject<any>();
  public markerFlatNumber = new Subject<any>();
  public markerUnitNumberSVG = new Subject<any>();
  public markerFlatNumberClick = new Subject<any>();
  public ifThree = new Subject<boolean>();
  public searchParameters = new Subject<any>();
  public itemsToFilter = new Subject<any>();
  public filterProp = new Subject<any>();
  public removeMenu = new Subject<boolean>();
  public curCompany = new Subject<any>();
  public curBuilding = new Subject<any>();
  public currentFlatsPanelOnClickShow = new Subject<any>();


  public openPopupFlatData = new Subject<any>();
  public data = new Subject<any>();
  public collection: string;
  public documentsOfCol: Item[];
  public collections: any;
  public compositeDesign: boolean = false;
  public unika: boolean = false;
  public unikaFixDesignCompany: any[] = ['HEWY8vUlp53MK5L6Ltm7', '8eoAJaAB0kQfJEOuKveC', 'miC7suXDlQrMasKFtn0W']
  sehelProjId: any;
  constructor(public afs: AppFirestoreService,
    private storage: AngularFireStorage,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient) { }
  private item: any;

  getRoutParam = this.route.snapshot.paramMap.get("id");

  // public compositeDesign() {
  //   const segment = this.route.snapshot._urlSegment.children.primary.segments;
  //   if(segment.length > 3){
  //     if(segment[4].path === 'n'){
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }
  // }



  wichDesign() {
    let pathArray = window.location.pathname.split('/');
    let urlSwitcher
    // if (pathArray[2] === 'n') {
    //   this.compositeDesign = true;
    //   urlSwitcher = '/company/n/'
    // } else
      if (pathArray[2] === 'u') {
      this.compositeDesign = true;
      this.unika = true;
      urlSwitcher = '/company/u/'
    } else {
      urlSwitcher = '/company/'
    }
    if (pathArray[3]) {
      this.unikaFixDesignCompany.forEach(compId => {
        if (pathArray[3] === compId || pathArray[2] === compId) {
          urlSwitcher = '/company/u/';
          this.unika = true;
        }
      })
    }
    return { compositeDesign: this.compositeDesign, unika: this.unika, urlSwitcher: urlSwitcher };
  }

  hoisUrlGetTitle() {
    switch (window.location.host) {
      case 'habaitproject.co.il':
        return 'Habait';
        break;
      case 'spirical.net':
        return 'Spirikal';
        break;
      case 'spirical-maps.firebaseapp.com':
        return 'Spirikal';
        break;
      case 'https://sys.spirikal.com':
        return 'Spirikal';
        break;
      case 'localhost:4200':
        return 'SpirikalLocalHost';
        break;
      default:
        return 'Spirikal';
    }
  }

  hoisUrl() {
    return "https://" + window.location.host;
    // return "https://habaitproject.co.il";
  }


  compData = this.afs
    .collection('comp')
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Item;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    );

  buildData = this.afs
    .collection('buildings')
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Item;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    );

  usersData = this.afs
    .collection('users')
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Item;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    );

  showFloorPlanInProject(floorId) {
    this.floorIdPlane.next(floorId);
  }
  showBuildingFromMenu(itemBuild) {
    this.showBuilding.next(itemBuild);
    // console.log('showBuilding-data-service', itemBuild);
  }
  getDataCurrentProj() {
    return this.currentProj;
  }
  getDataCurrentBuilding() {
    return this.currentBuilding;
  }
  currentBuild(building) {
    this.currentBuilding.next(building);
  }
  setCurrentUnit(unit) {
    this.currentUnit.next(unit);
  }

  currentProject(proj) {
    this.currentProj.next(proj);
  }
  currentCompany(company) {
    this.currentComp.next(company);
  }
  // view media function
  viewMediaSingle(items) {
    const pathReference = this.storage.ref(items[0].media[0].path);
    pathReference.getDownloadURL().subscribe((url: any) => {
      items[0].media[0].img = '<img src="' + url + '"/>';
    });
  }

  viewMedia(items, method) {
    for (let i = 0; i < items.length; i++) {
      const newArr: any[] = [];
      for (let y = 0; y < items[i].media.length; y++) {

        // just url
        if (method === 'path') {
          // push names of files to url
          newArr.push({ 'name': items[i].media[y].name, 'smallPath': items[i].media[y].path });
        }
        if (items[i].media[y].path !== undefined) {
          const pathReference = this.storage.ref(items[i].media[y].path);
          pathReference.getDownloadURL().subscribe((url: any) => {
            shareReplay();
            if (method === 'path') {
              // push url
              newArr.push({ 'path': url });
              //  newArr[0].path = url;
              //  items[i].media = newArr;
              // push element
            } else {
              if (items[i].media.length > -1) {
                if (items[i].media[y] !== undefined) {
                  if (method === 'pdf') {
                    items[i].media[y].img = '<iframe src="' + url + '"></iframe>';
                  } else {
                    items[i].media[y].img = '<img src="' + url + '"/>';
                  }
                }
              } else {
                if (items[i].video.length > 0) {
                  items[i].media.push({ 'img': items[i].video, 'smallPath': y });
                }
              }
              if (items[i].media.length - 1 === y) {
                if (items[i].video) {
                  items[i].media.push({ 'img': items[i].video, 'smallPath': y });
                }
              }
            }

            if (method === 'path') {
              items[i].media = newArr;
            }
            // }
          });
        }


      }
      if (items[i].video) {
        items[i].media.push({ 'img': items[i].video, 'smallPath': 0 });
      }
    }
  }

  viewVIdeo(items, method) {
    for (let i = 0; i < items.length; i++) {
      if (items[i].video) {
        items[i].media.push({ 'img': items[i].video, 'smallPath': i });
      }
    }
  }
  saveRemoveMenu(data) {
    this.removeMenu.next(data);
  }
  saveifThree(data) {
    this.ifThree.next(data);
  }
  saveItemsToFilter(data) {
    this.itemsToFilter.next(data);
  }
  flatProperties(data) {
    this.showFlatProperties.next(data);
  }

  saveCurProjects(data) {
    this.curProjects.next(data);
  }
  saveNumRoomsFilter(data) {
    this.numRoomsFilter.next(data);
  }
  savePrototypeFilter(data) {
    this.currentPrototype.next(data);
  }
  saveFullWidthPropertiesFlatPanel(data) {
    this.fullWidthPropertiesFlatPanel.next(data);
  }
  savecurrentFlatsPanelOnClickShow(data) {
    this.currentFlatsPanelOnClickShow.next(data);
  }
  saveCurBuilding(data) {
    this.curBuilding.next(data);
  }
  saveFlatStatusClass(data) {
    this.flatStatusClass.next(data);
  }
  saveFloorsNumbers(data) {
    this.floorsNumbers.next(data);
  }
  markerFlatOnHover(data) {
    this.markerFlatNumber.next(data);
  }
  markerUnitOnHoverSVG(data) {
    this.markerUnitNumberSVG.next(data);
  }
  markerFlatOnClick(data) {
    this.markerFlatNumberClick.next(data);
  }
  saveSearchParameters(data) {
    this.searchParameters.next(data);
  }

  saveFilterProp(data) {
    this.filterProp.next(data);
  }
  saveCurCompany(data) {
    this.curCompany.next(data);
  }
  openFlatInfoMobile(open) {
    this.openPopupFlatData.next(open);
  }
  openProjectClickOnMarker(data) {
    this.data.next(data);
  }



  public getItemsByCompId = compId =>
    this.afs
      .collection('markers', ref => ref.where('parrentId', '==', compId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.compId = compId;
            return data;
          });
        })
      )

  public showAllBuildingsByCompId = compId =>
    this.afs
      .collection('buildings', ref => ref.where('compId', '==', compId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.compId = compId;
            return data;
          });
        })
      )
  public showAllBuildingsByProjId = projId =>
    this.afs
      .collection('buildings', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

  public getPagesWithLink = parentId =>
    this.afs
      .collection('pages', ref => ref.where('parentId', '==', parentId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Page;
            data.id = a.payload.doc.id;
            this.parentId = parentId;
            return data;
          });
        })
      )


  public getItemsByProjId = projId =>

    this.afs
      .collection('buildings', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            tap(() => console.log(`readBuildings ${projId.length} docs`)),
              shareReplay();
            const data = a.payload.doc.data() as Building;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

  public getItemsByProjUid = projUid =>

    this.afs
      .collection('buildings', ref => ref.where('projId', '==', projUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            tap(() => console.log(`readBuildings ${projUid.length} docs`)),
              shareReplay();
            const data = a.payload.doc.data() as Building;
            data.id = a.payload.doc.id;
            // this.projId = projId;
            return data;
          });
        })
      )


  public getConstructionPointsByProjId = projId =>
    this.afs
      .collection('construction-points', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

  public getConstructionPointsByProjUid = projUid =>
    this.afs
      .collection('construction-points', ref => ref.where('projUid', '==', projUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projUid = projUid;
            return data;
          });
        })
      )

  public getConstructionPointsByProjUid1 = projUid =>
    this.afs
      .collection('construction-points', ref => ref.where('projUid', '>', projUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projUid = projUid;
            return data;
          });
        })
      )

  public getGallaryByProjId = projId =>
    this.afs
      .collection('galleries', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

  public getBuildingSimulator = buildUid =>
    this.afs
      .collection('buildingSimulator', ref => ref.where('buildUid', '==', buildUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.buildUid = buildUid;
            return data;
          });
        })
      )

  public getVideoByProjId = projId =>
    this.afs
      .collection('videos', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

  public getPDFByProjId = projId =>
    this.afs
      .collection('pdf', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )


  public getFlatPrototypesByProjId = projId =>
    this.afs
      .collection('flat-prototypes', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as FlatPrototype;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )

      public getFlatPrototypesByProjUid = projUid =>
        this.afs
          .collection('flat-prototypes', ref => ref.where('projUId', '==', projUid))
          .snapshotChanges()
          .pipe(
            map(changes => {
              return changes.map(a => {
                const data = a.payload.doc.data() as FlatPrototype;
                data.id = a.payload.doc.id;
                this.projUid = projUid;
                return data;
              });
            })
          )



  public getUsersByCompId = compId =>
    this.afs
      .collection('users', ref => ref.where('compId', '==', compId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as FlatPrototype;
            data.id = a.payload.doc.id;
            this.compId = compId;
            return data;
          });
        })
      )

  public getAreaByProjId = projId =>
    this.afs
      .collection('area', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )
  public getAreaAll = projId =>
    this.afs
      .collection('markers')
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            if (data.id !== a.payload.doc.id) {
              console.log(data);
            }
            data.key = a.payload.doc.id;
            // data.id = a.payload.doc.id;
            return (data);
          });
        })
      )
  public getGallery() {
    // const snapshot = this.afs.collection('galleries').get()
    // this.afs.collection('galleries').doc("4Sq2WCSicD4c6guFaN93").collection("4Sq2WCSicD4c6guFaN93images").ref.get().then(items => {

    // })
    // console.log(snapshot);
    // snapshot.subscribe(items => {
    //   console.log
    // })
    // const backups = require('firestore-export-import')

    // backups(['galleries', 'area']) // Array of collection's name is OPTIONAL
    //   .then((collections) => {
    //     // You can do whatever you want with collections
    //     console.log(JSON.stringify(collections))
    //   })
    // const  backups  = require('firestore-export-import')

    // backups(['collectionName1', 'collectionName2']) // Array of collection's name is OPTIONAL
    //   .then((collections) => {
    //     // You can do whatever you want with collections
    //     console.log(JSON.stringify(collections))
    //   })
  }
  // async getMarkers() {
  //   const markers = [];
  //   await this.afs.collection('galleries').doc().get().then(querySnapshot => {
  //       querySnapshot.docs.forEach(doc => {
  //       markers.push(doc.data());
  //     });
  //   });
  //   return markers;
  // }



  public getAllContent() {
    let collections: any = {};
    const collectionArray = ['galleries'];
    collectionArray.forEach(collection => {
      this.collection = collection;
      this.getAll().subscribe(items => {
      });
    })
  }
  public getAll = () =>
    this.afs
      .collection(this.collection).get()
      // .snapshotChanges()
      // .valueChanges()
      .pipe(
        map(changes => {
          // return changes.map(a => {
          //   const data = a.payload.doc.data() as Item;
          //   data.key = a.payload.doc.id;
          //   return (data);
          // });
        })
      )


  public getClientsByProjId = projId =>
    this.afs
      .collection('clients', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Client;
            data.id = a.payload.doc.id;
            this.projId = projId;
            return data;
          });
        })
      )



  public getItemsByFloorId = buildId =>
    this.afs
      .collection('floors', ref => ref.where('buildId', '==', buildId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.buildId = buildId;
            return data;
          });
        })
      )

  public getFlatsByFloorId = floorId =>
    this.afs
      .collection('flats', ref => ref.where('floorId', '==', floorId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.floorId = floorId;
            return data;
          });
        })
      )

  public getOffersByProjId = projId =>
    this.afs
      .collection('offers', ref => ref.where('projId', '==', projId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            // this.floorId = floorId;
            return data;
          });
        })
      )


      public getOffersByProjUid = projUid =>
        this.afs
          .collection('offers', ref => ref.where('projuId', '==', projUid))
          .snapshotChanges()
          .pipe(
            map(changes => {
              return changes.map(a => {
                const data = a.payload.doc.data() as Item;
                data.id = a.payload.doc.id;
                // this.floorId = floorId;
                return data;
              });
            })
          )


  // public getSpecFlat = projId =>
  //   this.afs
  //     .collection('flats', ref => ref.where('id', '==', projId))
  //     .snapshotChanges()
  //     .pipe(
  //       map(changes => {
  //         return changes.map(a => {
  //           const data = a.payload.doc.data() as Item;
  //           data.id = a.payload.doc.id;
  //           this.projId = projId;
  //           return data;
  //         });
  //       })
  //     )





  public getSpecialOffer = offerUid =>
    this.afs
      .collection('offers', ref => ref.where('uid', '==', offerUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            // this.flat = flatUid;
            return data;
          });
        })
      )


  public getSpecComp = compId =>
    this.afs
      .collection('comp', ref => ref.where('id', '==', compId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          shareReplay();
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      )

  public getSpecCompByName = compName =>
    this.afs
      .collection('comp', ref => ref.where('name', '==', compName))
      .snapshotChanges()
      .pipe(
        map(changes => {
          shareReplay();
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      )


  public getSpecFlatPrototypeView = prototypeId =>
    this.afs
      .collection('flat-prototypes', ref => ref.where('uid', '==', prototypeId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.prototypeId = prototypeId;
            return data;
          });
        })
      )

  public getSpecFlat = flatUid =>
    this.afs
      .collection('flats', ref => ref.where('uid', '==', flatUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.flat = flatUid;
            return data;
          });
        })
      )

  public getSpecProject = projUid =>
    this.afs
      .collection('markers', ref => ref.where('uid', '==', projUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.projUid = projUid;
            return data;
          });
        })
      )

  public getSpecParking = buildId =>
    this.afs
      .collection('parking', ref => ref.where('buildId', '==', buildId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            // this.projUid = projUid;
            return data;
          });
        })
      )


  public getSpecProjectSehel = sehelProjId =>
    this.afs
      .collection('markers', ref => ref.where('sehelProjId', '==', sehelProjId))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.sehelProjId = sehelProjId;
            return data;
          });
        })
      )

  public getAllProjects =
    this.afs
      .collection('markers')
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      )

  public getAllBuilding =
    this.afs
      .collection('buildings')
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      )

  public getSpecBuilding = buildUid =>
    this.afs
      .collection('buildings', ref => ref.where('uid', '==', buildUid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Building;
            data.id = a.payload.doc.id;
            this.buildUid = buildUid;
            data.floors[0].floor.ranking
            let floorsArray = [];
            // change range to invers for compare with SEHEL
            data.floors.forEach(floor => {
              if (!floor.floor.ranking || floor.floor.ranking === '' || floor.floor.ranking !== 0) {
                floor.floor.ranking = 0;
                floorsArray.push(floor);
              } else {
                floorsArray[floor.floor.ranking - 1] = floor;
              }
            })

            data.floors = floorsArray;
            return data;
          });
        })
      )

  public getSpecOffer = uid =>
    this.afs
      .collection('offers', ref => ref.where('uid', '==', uid))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data();
            return data;
          });
        })
      )

  public getSelectedBuilding = id =>
    this.afs
      .collection('buildings', ref => ref.where('uid', '==', id))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Building;
            return data;
          });
        })
      )

  public getSpecProj = proj =>
    this.afs
      .collection('markers', ref => ref.where('id', '==', proj))
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.buildUid = proj;
            return data;
          });
        })
      )



  public getFlatPrototype = flatPrototypeId =>
    this.afs
      .collection('flat-prototype', ref =>
        ref.where('id', '==', flatPrototypeId)
      )
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Item;
            data.id = a.payload.doc.id;
            this.flatPrototypeId = flatPrototypeId;
            return data;
          });
        })
      )


  addItem(data, collection) {
    this.afs.collection(collection).add(data);
  }

  addItemWithOwnerId(data, collection) {
    data.map(items => {
      this.afs.collection(collection).doc(items.id).set(items);
    })
  }

  getItems(collection) {
    if (collection === 'markers') {
      return this.items;
    } else if (collection === 'comp') {
      return this.compData;
    } else if (collection === 'buildings') {
      return this.buildData;
    } else if (collection === 'users') {
      return this.usersData;
    }
  }

  deleteItem(item, collection) {
    this.itemDoc = this.afs.doc(collection + '' + item.id);
    this.itemDoc.delete();
  }

  updateItem(item, collection) {
    // if(item !== undefined){
    this.itemDoc = this.afs.doc(collection + `${item.id}`);
    this.itemDoc.update(item);
    // }
  }

  // latter for flat prototypes from add-flat-prototype.component
  addFaltProperty(item, collection) {
    this.itemDoc = this.afs.doc(collection + `${item.id}`);
    this.itemDoc.update(item);
  }

  // sort() {
  //   this.items
  //   .subscribe()
  //   .sort((a: Item[], b: Item[]) => {
  //       return a.date.valueOf() - b.date.valueOf();
  //     });
  // }

  postSehel(action, postDataData, sehelProjId?) {

    let postData: any = {}
    postData = postDataData;
    postData.token = "spirikal-427c-4921-927b-795020264f93";
    let url: string = '';
    if (action === 'sendWhatsapp') {
      this.sehelDomain = 'https://crm.sehel.co.il/api/3d/';
      url = this.sehelDomain + action + '/' + sehelProjId;
    } else if (action === 'setAction') {
      url = this.sehelDomain + action;
    }
    postData = JSON.stringify(postData);
    // this.http.post<any>('https://dev.sehel.co.il/api/3d/sendWhatsapp/a246afb5-427c-4921-927b-795020264f93', postData).subscribe(data => {
    this.http.post<any>(url, postData).subscribe(data => {
      console.log('data', data);
    });
  }


}


